import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from "prop-types";
import { useState } from "react";

import SiteIcons from "@/components/SiteIcons/SiteIcons";
import "@/components/membership/Dashboard/Dashboard.css";

function AreYouSureModal({
  id,
  handleAction,
  title = "Delete this item",
  iconString = "delete-outlined",
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (userIsSure) => {
    if (userIsSure) {
      handleAction(id);
    }
    handleClose();
  };

  return (
    <>
      <SiteIcons iconstring={iconString} onClick={handleClickOpen} />

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle className="seiu-modal-header">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="siteBlueOutlined"
            onClick={() => handleClick(false)}
          >
            Cancel
          </Button>
          <Button className="siteRedOutlined" onClick={() => handleClick(true)}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

//dashboard and templates table are giving id different datatypes

AreYouSureModal.propTypes = {
  id: PropTypes.any,
  handleAction: PropTypes.func,
  title: PropTypes.string,
};

export default AreYouSureModal;
